export function formatValueWithTwoDecimals(value: number | string) {
  if (typeof value !== 'number' && typeof value !== 'string') {
    return null;
  }

  return (+value).toFixed(2);
}
